export const defaultReturnTo = (): string => `${window.location.pathname}${window.location.search}`;
